import React from 'react';

function SuccessIcon() {
  return (
    <span className="ws-ui-success-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        className="ws-ui-success-icon__circle"
      >
        <circle cx="12" cy="12" r="10" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="40 40"
        className="ws-ui-success-icon__check"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
  );
}

export default SuccessIcon;
